export default "__VITE_ASSET__DJlFxtOw__"